import fetchApi from "./fetchApi";
import { actionTypes, CheckProductQuarantined } from "./Actions";

const checkProductQuarantined: CheckProductQuarantined = (
  productId,
  spidId
) =>
  fetchApi(
    `/bestilling/api/v2/ff/product/${productId}/quarantined.json?spidId=${spidId}`,
    actionTypes.SET_PRODUCT_QUARANTINED
  );

export default checkProductQuarantined;
